import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './HannyaMessages.css';

function HannyaMessages() {
  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('hannyaToken');

  useEffect(() => {
    if (token) {
      loadMessages();
    }
  }, [token]);

  const loadMessages = async () => {
    try {
      const data = await api.getMessages(token);
      if (Array.isArray(data)) {
        setMessages(data);
      }
    } catch (error) {
      console.error('Erro:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleMarkAsRead = async (id) => {
    try {
      await api.markAsRead(id, token);
      await loadMessages();
    } catch (error) {
      console.error('Erro:', error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza?')) {
      try {
        await api.deleteMessage(id, token);
        await loadMessages();
        if (selectedMessage?._id === id) {
          setSelectedMessage(null);
        }
      } catch (error) {
        console.error('Erro:', error);
      }
    }
  };

  const filteredMessages = messages.filter(msg => {
    if (filter === 'unread') return !msg.lido;
    if (filter === 'read') return msg.lido;
    return true;
  });

  const getServicoLabel = (servico) => {
    const labels = {
      ecommerce: 'E-commerce',
      portfolio: 'Portfólio',
      webapp: 'Web App',
      landing: 'Landing Page',
      outro: 'Outro'
    };
    return labels[servico] || servico;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return 'Data não disponível';
    const date = new Date(dateStr);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="hannya-messages">
        <div className="messages-content">
          <div className="no-selection">
            <i className="fas fa-spinner fa-pulse"></i>
            <p>Carregando mensagens...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="hannya-messages">
      <div className="messages-header">
        <div className="messages-filters">
          <button 
            className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
            onClick={() => setFilter('all')}
          >
            Todas ({messages.length})
          </button>
          <button 
            className={`filter-btn ${filter === 'unread' ? 'active' : ''}`}
            onClick={() => setFilter('unread')}
          >
            Não lidas ({messages.filter(m => !m.lido).length})
          </button>
          <button 
            className={`filter-btn ${filter === 'read' ? 'active' : ''}`}
            onClick={() => setFilter('read')}
          >
            Lidas ({messages.filter(m => m.lido).length})
          </button>
        </div>
      </div>

      <div className="messages-content">
        <div className="messages-list">
          {filteredMessages.length === 0 ? (
            <div className="no-messages">
              <i className="fas fa-inbox"></i>
              <p>Nenhuma mensagem encontrada</p>
            </div>
          ) : (
            filteredMessages.map(msg => (
              <div 
                key={msg._id} 
                className={`message-item ${!msg.lido ? 'unread' : ''} ${selectedMessage?._id === msg._id ? 'selected' : ''}`}
                onClick={() => setSelectedMessage(msg)}
              >
                <div className="message-status">
                  {!msg.lido && <span className="unread-dot"></span>}
                </div>
                <div className="message-info">
                  <h4>{msg.nome}</h4>
                  <p>{msg.email}</p>
                  <span className="message-date">{formatDate(msg.createdAt)}</span>
                </div>
                <div className="message-actions">
                  {!msg.lido && (
                    <button 
                      className="action-btn read-btn"
                      onClick={(e) => { e.stopPropagation(); handleMarkAsRead(msg._id); }}
                      title="Marcar como lido"
                    >
                      <i className="fas fa-check"></i>
                    </button>
                  )}
                  <button 
                    className="action-btn delete-btn"
                    onClick={(e) => { e.stopPropagation(); handleDelete(msg._id); }}
                    title="Excluir"
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="messages-detail">
          {selectedMessage ? (
            <div className="message-detail-card">
              <div className="detail-header">
                <h3>Detalhes da mensagem</h3>
                <button className="close-detail" onClick={() => setSelectedMessage(null)}>
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="detail-field">
                <label><i className="fas fa-user"></i> Nome</label>
                <p>{selectedMessage.nome}</p>
              </div>
              <div className="detail-field">
                <label><i className="fas fa-envelope"></i> E-mail</label>
                <p>{selectedMessage.email}</p>
              </div>
              <div className="detail-field">
                <label><i className="fas fa-phone"></i> Telefone</label>
                <p>{selectedMessage.telefone || 'Não informado'}</p>
              </div>
              <div className="detail-field">
                <label><i className="fas fa-building"></i> Empresa</label>
                <p>{selectedMessage.empresa || 'Não informada'}</p>
              </div>
              <div className="detail-field">
                <label><i className="fas fa-code"></i> Tipo de serviço</label>
                <p>{getServicoLabel(selectedMessage.servico)}</p>
              </div>
              <div className="detail-field">
                <label><i className="fas fa-chart-line"></i> Faixa de orçamento</label>
                <p>R$ {selectedMessage.orcamento}</p>
              </div>
              <div className="detail-field">
                <label><i className="fas fa-comment"></i> Mensagem</label>
                <p className="message-text">{selectedMessage.mensagem}</p>
              </div>
              <div className="detail-field">
                <label><i className="fas fa-calendar"></i> Data de envio</label>
                <p>{formatDate(selectedMessage.createdAt)}</p>
              </div>
              <div className="detail-actions">
                {!selectedMessage.lido && (
                  <button className="mark-read-btn" onClick={() => handleMarkAsRead(selectedMessage._id)}>
                    <i className="fas fa-check-circle"></i> Marcar como lido
                  </button>
                )}
                <button className="reply-btn" onClick={() => window.location.href = `mailto:${selectedMessage.email}`}>
                  <i className="fas fa-reply"></i> Responder
                </button>
              </div>
            </div>
          ) : (
            <div className="no-selection">
              <i className="fas fa-envelope-open-text"></i>
              <p>Selecione uma mensagem para visualizar os detalhes</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HannyaMessages;